// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Global Container --- */
.user-page {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  background: #f2eee6;
  padding: 0 0 50px;
}

.user-page .user-account-header {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f2eee6;
  color: #10202b;
  box-sizing: border-box;
}

.user-page .user-account-header h1 {
  margin: 0;
  font-family: "Playfair Display", serif;
  font-size: 44px;
  font-weight: 400;
  line-height: 1;
}

.user-page .user-account-header span {
  width: 42px;
  height: 1px;
  margin-top: 14px;
  background: #b88a44;
}

.user-page .user-account-header p {
  margin: 12px 0 0;
  color: #5f6b73;
  font: 400 13px/1.5 "Poppins", sans-serif;
  letter-spacing: .025em;
}

.user-page .css-heg063-MuiTabs-flexContainer {
  flex-direction: column;
}

.user-page .css-mn3ro6-MuiTabs-indicator {
  height: 0px;
  width: 0px;
}

.user-page .css-1ujnqem-MuiTabs-root {
  width: 100%;
}

.user-page .my-page-frame {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  padding: 50px 0;
}

/* --- Left Column --- */
.my-page-frame .my-page-left {
  width: 70%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.my-page-left .menu-name {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid rgba(16, 32, 43, 0.10);
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 45px;
  color: #b88a44;
}

/* --- Settings Form (Styled as the Box) --- */
.user-page .settings {
  width: 95%;
  height: auto;
  display: flex;
  flex-direction: column;
  background: #fbf8f2; /* Added Box Background */
  padding: 40px;      /* Added Padding */
  border-radius: 16px;/* Added Rounded Corners */
  border: 1px solid rgba(16, 32, 43, 0.10);
  box-shadow: 0 10px 24px rgba(16, 32, 43, 0.08);
  margin-top: 20px;
}

.user-page .settings .input-frame {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
}

.user-page .settings .short-input,
.user-page .settings .long-input {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.user-page .settings .spec-label {
  font-family: 'Source Serif Pro', serif;
  font-size: 16px;
  color: #b88a44;
}

.user-page .settings .spec-input,
.user-page .settings .spec-textarea {
  position: relative;
  margin-top: 10px;
  padding: 20px;
  width: 100%;
  border: 1px solid rgba(16, 32, 43, 0.10);
  background: #e8e1d7; /* Input Field Background */
  border-radius: 5px;
  font-family: 'GT Walsheim Pro', sans-serif;
  color: #10202b;
}

.user-page .settings .spec-textarea {
  height: 200px;
}

.user-page .settings .member-media-frame {
  margin-top: 25px;
  padding: 10px;
  width: 100%;
  display: flex;
  border-radius: 5px;
}

.user-page .settings .member-media-frame .mb-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.user-page .settings .media_change-box {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
}

.user-page .settings .media-change-box span {
  font-family: 'GT Walsheim Pro', sans-serif;
  color: #b88a44;
}

.user-page .settings .media-change-box p {
  margin: 10px 0px 14px 0px;
  color: #5f6b73;
}

.user-page .settings .up-del-box {
  width: 37px;
  height: 37px;
  display: flex;
  background: #e8e1d7;
  border: 1px solid rgba(16, 32, 43, 0.10);
  border-radius: 8px;
  justify-content: center;
  align-items: center;
}

.user-page .settings .save-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 25px;
}

/* --- Right Column (Profile Card) --- */
.my-page-frame .my-page-right {
  margin-left: 30px;
  width: 30%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.user-page .order-info-box {
  position: relative;
  padding: 20px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fbf8f2;
  box-shadow: 0 10px 24px rgba(16, 32, 43, 0.08);
  border: 1px solid rgba(16, 32, 43, 0.10);
  border-radius: 16px;
}

.user-page .order-info-box .settings-btn {
  position: absolute;
  top: 6%;
  right: 19%;
  cursor: pointer;
}

.user-page .order-info-box .order-user-img {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.user-page .order-info-box .order-user-img .order-user-avatar {
  width: 150px;
  height: 150px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  border-radius: 37px;
}

.user-page .order-info-box .order-user-icon-box {
  position: absolute;
  padding: 5px;
  width: 37px;
  height: 37px;
  top: 81%;
  right: 0;
  display: flex;
  background: #e8e1d7;
  border-radius: 37px;
}

.user-page .order-info-box .order-user-name {
  margin-top: 10px;
  font-family: 'Commissioner', sans-serif;
  font-weight: 500;
  font-size: 28px;
  color: #10202b;
}

.user-page .order-info-box .order-user-prof {
  font-family: 'Commissioner', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #b88a44;
}

.user-page .order-info-box .user-media-box {
  margin-top: 10px;
  width: 60%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.user-page .order-info-box .user-desc {
  margin-top: 30px;
  width: 90%;
  display: flex;
  justify-content: center;
  font-family: 'DM Sans', sans-serif;
  color: #5f6b73;
}

.user-page .order-info-box .css-1e3kzd4-MuiButtonBase-root-MuiButton-root {
  margin-top: 15px;
  min-width: 90%;
  height: 44px;
  text-transform: capitalize;
  font-weight: 600;
  font-size: 25px;
  color: #10202b;
}

.user-page .menu-box img {
  width: 25px;
}

.user-page .menu-box span {
  margin-left: 30px;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 25px;
  color: #10202b;
}`, "",{"version":3,"sources":["webpack://./src/css/userPage.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,+CAA+C;EAC/C,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,yBAAyB;EAC9C,aAAa,OAAO,kBAAkB;EACtC,mBAAmB,CAAC,0BAA0B;EAC9C,wCAAwC;EACxC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,wCAAwC;EACxC,mBAAmB,EAAE,2BAA2B;EAChD,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* --- Global Container --- */\n.user-page {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  background: #f2eee6;\n  padding: 0 0 50px;\n}\n\n.user-page .user-account-header {\n  width: 100%;\n  height: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #f2eee6;\n  color: #10202b;\n  box-sizing: border-box;\n}\n\n.user-page .user-account-header h1 {\n  margin: 0;\n  font-family: \"Playfair Display\", serif;\n  font-size: 44px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.user-page .user-account-header span {\n  width: 42px;\n  height: 1px;\n  margin-top: 14px;\n  background: #b88a44;\n}\n\n.user-page .user-account-header p {\n  margin: 12px 0 0;\n  color: #5f6b73;\n  font: 400 13px/1.5 \"Poppins\", sans-serif;\n  letter-spacing: .025em;\n}\n\n.user-page .css-heg063-MuiTabs-flexContainer {\n  flex-direction: column;\n}\n\n.user-page .css-mn3ro6-MuiTabs-indicator {\n  height: 0px;\n  width: 0px;\n}\n\n.user-page .css-1ujnqem-MuiTabs-root {\n  width: 100%;\n}\n\n.user-page .my-page-frame {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  padding: 50px 0;\n}\n\n/* --- Left Column --- */\n.my-page-frame .my-page-left {\n  width: 70%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.my-page-left .menu-name {\n  width: 100%;\n  height: 70px;\n  display: flex;\n  justify-content: center;\n  border-bottom: 1px solid rgba(16, 32, 43, 0.10);\n  font-family: 'Poppins', sans-serif;\n  font-weight: 600;\n  font-size: 45px;\n  color: #b88a44;\n}\n\n/* --- Settings Form (Styled as the Box) --- */\n.user-page .settings {\n  width: 95%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  background: #fbf8f2; /* Added Box Background */\n  padding: 40px;      /* Added Padding */\n  border-radius: 16px;/* Added Rounded Corners */\n  border: 1px solid rgba(16, 32, 43, 0.10);\n  box-shadow: 0 10px 24px rgba(16, 32, 43, 0.08);\n  margin-top: 20px;\n}\n\n.user-page .settings .input-frame {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.user-page .settings .short-input,\n.user-page .settings .long-input {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.user-page .settings .spec-label {\n  font-family: 'Source Serif Pro', serif;\n  font-size: 16px;\n  color: #b88a44;\n}\n\n.user-page .settings .spec-input,\n.user-page .settings .spec-textarea {\n  position: relative;\n  margin-top: 10px;\n  padding: 20px;\n  width: 100%;\n  border: 1px solid rgba(16, 32, 43, 0.10);\n  background: #e8e1d7; /* Input Field Background */\n  border-radius: 5px;\n  font-family: 'GT Walsheim Pro', sans-serif;\n  color: #10202b;\n}\n\n.user-page .settings .spec-textarea {\n  height: 200px;\n}\n\n.user-page .settings .member-media-frame {\n  margin-top: 25px;\n  padding: 10px;\n  width: 100%;\n  display: flex;\n  border-radius: 5px;\n}\n\n.user-page .settings .member-media-frame .mb-image {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.user-page .settings .media_change-box {\n  margin-left: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.user-page .settings .media-change-box span {\n  font-family: 'GT Walsheim Pro', sans-serif;\n  color: #b88a44;\n}\n\n.user-page .settings .media-change-box p {\n  margin: 10px 0px 14px 0px;\n  color: #5f6b73;\n}\n\n.user-page .settings .up-del-box {\n  width: 37px;\n  height: 37px;\n  display: flex;\n  background: #e8e1d7;\n  border: 1px solid rgba(16, 32, 43, 0.10);\n  border-radius: 8px;\n  justify-content: center;\n  align-items: center;\n}\n\n.user-page .settings .save-box {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 25px;\n}\n\n/* --- Right Column (Profile Card) --- */\n.my-page-frame .my-page-right {\n  margin-left: 30px;\n  width: 30%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.user-page .order-info-box {\n  position: relative;\n  padding: 20px;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #fbf8f2;\n  box-shadow: 0 10px 24px rgba(16, 32, 43, 0.08);\n  border: 1px solid rgba(16, 32, 43, 0.10);\n  border-radius: 16px;\n}\n\n.user-page .order-info-box .settings-btn {\n  position: absolute;\n  top: 6%;\n  right: 19%;\n  cursor: pointer;\n}\n\n.user-page .order-info-box .order-user-img {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.user-page .order-info-box .order-user-img .order-user-avatar {\n  width: 150px;\n  height: 150px;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\n  border-radius: 37px;\n}\n\n.user-page .order-info-box .order-user-icon-box {\n  position: absolute;\n  padding: 5px;\n  width: 37px;\n  height: 37px;\n  top: 81%;\n  right: 0;\n  display: flex;\n  background: #e8e1d7;\n  border-radius: 37px;\n}\n\n.user-page .order-info-box .order-user-name {\n  margin-top: 10px;\n  font-family: 'Commissioner', sans-serif;\n  font-weight: 500;\n  font-size: 28px;\n  color: #10202b;\n}\n\n.user-page .order-info-box .order-user-prof {\n  font-family: 'Commissioner', sans-serif;\n  font-weight: 500;\n  font-size: 20px;\n  color: #b88a44;\n}\n\n.user-page .order-info-box .user-media-box {\n  margin-top: 10px;\n  width: 60%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.user-page .order-info-box .user-desc {\n  margin-top: 30px;\n  width: 90%;\n  display: flex;\n  justify-content: center;\n  font-family: 'DM Sans', sans-serif;\n  color: #5f6b73;\n}\n\n.user-page .order-info-box .css-1e3kzd4-MuiButtonBase-root-MuiButton-root {\n  margin-top: 15px;\n  min-width: 90%;\n  height: 44px;\n  text-transform: capitalize;\n  font-weight: 600;\n  font-size: 25px;\n  color: #10202b;\n}\n\n.user-page .menu-box img {\n  width: 25px;\n}\n\n.user-page .menu-box span {\n  margin-left: 30px;\n  font-family: 'Poppins', sans-serif;\n  font-weight: 600;\n  font-size: 25px;\n  color: #10202b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
